export default "__VITE_ASSET__C0YUS52l__"